/**上传图片**/
<template>
  <div class="upImgDom">
    <div class="showImgList">
      <div class=" showImgItem frame" v-for="(item,index) in imgs" @click="showImgFn(item)">
        <img :src="weixinUrl+item">
      </div>
    </div>
    <div class="AddImg frame" v-if="imgs.length<maxNum" @click="AddFn">
      <b class="">+</b>
    </div>
    <input ref="inFile" type="file" name="photo" @change="fileFn1" v-if="mobileState.iPhone" accept="image/*"/>
    <input ref="inFile" type="file" name="photo" @change="fileFn1" accept="image/*"
           v-else-if="mobileState.Android"/>
    <input ref="inFile" type="file" name="photo" @change="fileFn1" accept="image/*"
           v-else=""/>
    <div class="showMaxImg" :class="showMaxImgState?'showMaxImgAction':''" v-if="showMaxImgState" @click="showMaxImgFn">
      <img :src="weixinUrl+showImgUrl">
      <div class="modal" v-if="showMaxImgState"></div>
    </div>
    <xk-upload-mod :state="loadState"></xk-upload-mod>
  </div>
</template>

<script>
  import InitData from '../../../../store/configure'
  import XkUploadMod from '../../uploadMod/src/uploadMod'
  import { mapGetters } from 'vuex'
  import Exif from 'exif-js'

  export default {
    components: {XkUploadMod},
    name: 'xk-upImgDom',
    props: ['actionUrl', 'maxNum'],
    computed: {
      ...mapGetters({
        mobileState: 'mobileState'
      })
    },
    data () {
      return {
        imgs: [],
        weixinUrl: InitData.weixinUrl,
        showImgUrl: '',
        showMaxImgState: false,
        loadState: false,
        headerImage: '',
        picValue: '',
        fileText: ''
      }
    },
    methods: {
      fileFn1: function (e) {
        let that = this
        that.loadSate = true
        let files = e.target.files || e.dataTransfer.files
        if (!files.length) return
        that.picValue = files[0]
        that.fileText = e.target.value
        that.imgPreview(this.picValue)
      },
      imgPreview (file) {
        let self = this
        let Orientation
        // 去获取拍照时的信息，解决拍出来的照片旋转问题
        Exif.getData(file, function () {
          Orientation = Exif.getTag(this, 'Orientation')
        })
        //  看支持不支持FileReader
        if (!file || !window.FileReader) return

        if (/^image/.test(file.type)) {
          //  创建一个reader
          let reader = new FileReader()
          //  将图片2将转成 base64 格式
          reader.readAsDataURL(file)
          //  读取成功后的回调
          reader.onloadend = function () {
            let result = this.result
            let img = new Image()
            img.src = result
            // 判断图片是否大于100K,是就直接上传，反之压缩图片
            if (this.result.length <= (100 * 1024)) {
              self.headerImage = this.result
              self.postImg()
            } else {
              img.onload = function () {
                let data = self.compress(img, Orientation)
                self.headerImage = data
                self.postImg()
              }
            }
          }
        }
      },
      postImg () {
        let that = this
        let data = this.headerImage
        data = data.split(',')[1]
        data = window.atob(data)
        let ia = new Uint8Array(data.length)
        for (let i = 0; i < data.length; i++) {
          ia[i] = data.charCodeAt(i)
        }
        // canvas.toDataURL 返回的默认格式就是 image/png
        let blob = new Blob([ia], {
          type: 'image/jpeg'
        })
        let fd = new FormData()
        fd.append('photo', blob, that.fileText)
        let xhr = new XMLHttpRequest()
        xhr.onload = function () {
          let data = JSON.parse(xhr.responseText)
          if (data.code === 0) {
            that.imgs.push('/' + data.data)
            that.loadState = false
            that.$emit('change', that.imgs)
          } else {
            that.loadState = false
          }
        }
        xhr.onerror = function () {}
        xhr.open('POST', InitData.weixinUrl + '/v5/paotui/upload')
        xhr.send(fd)
        // 这里写接口
      },
      rotateImg (img, direction, canvas) {
        // 最小与最大旋转方向，图片旋转4次后回到原方向
        const minStep = 0
        const maxStep = 3
        if (img == null) return
        // img的高度和宽度不能在img元素隐藏后获取，否则会出错
        let height = img.height
        let width = img.width
        let step = 2
        if (step == null) {
          step = minStep
        }
        if (direction === 'right') {
          step++
          // 旋转到原位置，即超过最大值
          step > maxStep && (step = minStep)
        } else {
          step--
          step < minStep && (step = maxStep)
        }
        // 旋转角度以弧度值为参数
        let degree = step * 90 * Math.PI / 180
        let ctx = canvas.getContext('2d')
        switch (step) {
          case 0:
            canvas.width = width
            canvas.height = height
            ctx.drawImage(img, 0, 0)
            break
          case 1:
            canvas.width = height
            canvas.height = width
            ctx.rotate(degree)
            ctx.drawImage(img, 0, -height)
            break
          case 2:
            canvas.width = width
            canvas.height = height
            ctx.rotate(degree)
            ctx.drawImage(img, -width, -height)
            break
          case 3:
            canvas.width = height
            canvas.height = width
            ctx.rotate(degree)
            ctx.drawImage(img, -width, 0)
            break
        }
      },
      compress (img, Orientation) {
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        // 瓦片canvas
        let tCanvas = document.createElement('canvas')
        let tctx = tCanvas.getContext('2d')
        //   let initSize = img.src.length
        let width = img.width
        let height = img.height
        // 如果图片大于四百万像素，计算压缩比并将大小压至400万以下
        let ratio
        if ((ratio = width * height / 400000000000000) > 1) {
          // console.log('大于400万像素')
          ratio = Math.sqrt(ratio)
          width /= ratio
          height /= ratio
        } else {
          ratio = 1
        }
        canvas.width = width
        canvas.height = height
        //         铺底色
        ctx.fillStyle = '#fff'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        // 如果图片像素大于100万则使用瓦片绘制
        let count
        if ((count = width * height / 100000000000000) > 1) {
          // console.log('超过100W像素')
          count = ~~(Math.sqrt(count) + 1) // 计算要分成多少块瓦片
          //             计算每块瓦片的宽和高
          let nw = ~~(width / count)
          let nh = ~~(height / count)
          tCanvas.width = nw
          tCanvas.height = nh
          for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
              tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh)
              ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh)
            }
          }
        } else {
          ctx.drawImage(img, 0, 0, width, height)
        }
        // 修复ios上传图片的时候 被旋转的问题
        if (Orientation !== '' && Orientation !== 1) {
          switch (Orientation) {
            case 6:// 需要顺时针（向左）90度旋转
              this.rotateImg(img, 'left', canvas)
              break
            case 8:// 需要逆时针（向右）90度旋转
              this.rotateImg(img, 'right', canvas)
              break
            case 3:// 需要180度旋转
              this.rotateImg(img, 'right', canvas)// 转两次
              this.rotateImg(img, 'right', canvas)
              break
          }
        }
        // 进行最小压缩
        let ndata = canvas.toDataURL('image/jpeg', 0.5)
        //  console.log('压缩前：' + initSize)
        //  console.log('压缩后：' + ndata.length)
        //  console.log('压缩率：' + ~~(100 * (initSize - ndata.length) / initSize) + '%')
        tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0
        return ndata
      },
      AddFn: function () {
        this.$refs.inFile.click()
      },
      showImgFn: function (url) {
        this.showMaxImgState = true
        this.showImgUrl = url
      },
      showMaxImgFn: function () {
        this.showMaxImgState = !this.showMaxImgState
      }
    },
    watch: {},
    mounted: function () {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .upImgDom {
    height: 3.1666rem;
    text-align: left;
    .showImgList {
      display: inline-block;
      vertical-align: middle;
      height: 100%;
      .showImgItem {
        box-sizing: border-box;
        display: inline-block;
        vertical-align: middle;
        height: 3.1666rem;
        width: 3.1666rem;
        position: relative;
        border: 1px solid #eee;
        background-color: #fff;
        margin: 0 0.25rem;
        img {
          height: 90%;
          width: 90%;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
    .AddImg {
      box-sizing: border-box;
      display: inline-block;
      vertical-align: middle;
      height: 3.1666rem;
      width: 3.1666rem;
      border: 1px dashed #eee;
      position: relative;
      background-color: #fff;
      b {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 1.5rem;
        color: #999;
        font-weight: bold;
      }
    }
    input {
      position: absolute;
      z-index: -100;
      opacity: 0;
      left: 0;
      top: 0;
    }
    .showMaxImg {
      position: fixed;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background-color: rgba(0, 0, 0, .5);
      img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 80%;
        z-index: 50;
        border: 1rem solid #fff;
      }
      .modal {
        position: absolute;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, .5);
      }
    }
    .showMaxImgAction {
      z-index: 100;
    }
  }
</style>



// WEBPACK FOOTER //
// upImg.vue?54ab628b